import { ReactNode } from 'react';
import classnames from 'classnames';

interface Props {
  center?: boolean;
  children: ReactNode;
  left?: boolean;
}

const Items = ({ children, center = false, left = false }: Props) => {
  const className = classnames({
    flex: true,
    'flex-row': true,
    'gap-2': true,
    'text-pill-color': true,
    'justify-center': center,
    'justify-start': left,
    'justify-end': !center && !left,
  });

  return <div className={className}>{children}</div>;
};

export default Items;
